// Shared utilities for admin pages.
export function fmtDate(iso, short = false) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return short
      ? d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" })
      : d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function fmtMoney(v) {
  if (v == null) return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return `£${n.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

const STATUS_TONE = {
  ACTIVE:        { bg: "bg-[#064E2E]/10", fg: "text-[#064E2E]" },
  PENDING:       { bg: "bg-[#B88A2A]/15", fg: "text-[#B88A2A]" },
  PAST_DUE:      { bg: "bg-[#DC2626]/10", fg: "text-[#DC2626]" },
  CANCELLED:     { bg: "bg-[#475569]/15", fg: "text-[#475569]" },
  EXPIRED:       { bg: "bg-[#475569]/15", fg: "text-[#475569]" },
  NEW:           { bg: "bg-[#B88A2A]/15", fg: "text-[#B88A2A]" },
  REVIEWING:     { bg: "bg-[#064E2E]/10", fg: "text-[#064E2E]" },
  AWAITING_INFO: { bg: "bg-[#475569]/15", fg: "text-[#475569]" },
  ADVISED:       { bg: "bg-[#064E2E]/10", fg: "text-[#064E2E]" },
  CLOSED:        { bg: "bg-[#475569]/15", fg: "text-[#475569]" },
  PAID:          { bg: "bg-[#064E2E]/10", fg: "text-[#064E2E]" },
  UNPAID:        { bg: "bg-[#B88A2A]/15", fg: "text-[#B88A2A]" },
  FAILED:        { bg: "bg-[#DC2626]/10", fg: "text-[#DC2626]" },
};

export function statusBadge(status) {
  if (!status) return null;
  const tone = STATUS_TONE[status] || { bg: "bg-[#E2DCD0]", fg: "text-[#071A33]" };
  return (
    <span className={`inline-block px-2 py-0.5 text-[10px] font-medium tracking-[0.1em] uppercase ${tone.bg} ${tone.fg}`}>
      {status}
    </span>
  );
}
